import React from "react";
import { Sparkles, Leaf } from "lucide-react";
import { CtaButton } from "@/components/CtaButton";
import { SITE } from "@/constants/testIds";

export const HomeIntroSection = () => (
    <section className="relative overflow-hidden bg-grain">
        <div className="absolute inset-0 hero-wash pointer-events-none" />
        <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 pt-12 pb-12 sm:pt-16 sm:pb-20">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                <div className="lg:col-span-7 reveal">
                    <p className="font-accent text-xs text-terracotta">
                        MAUI &middot; ONLINE &middot; SINCE 2021
                    </p>
                    <h1
                        data-testid={SITE.homeIntro}
                        className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em] text-moss"
                    >
                        Feel the nature of{" "}
                        <em className="text-terracotta not-italic">wellness</em>.
                    </h1>
                    <p className="mt-5 max-w-xl text-base sm:text-lg text-foreground/80 leading-relaxed">
                        Access the wisdom of Ayurveda from the slopes of Haleakalā on Maui &mdash; in person or anywhere in the world over Zoom. Individualized care plans, classical bodywork, herbs, and the daily practices that quietly return you to balance.
                    </p>
                    <div className="mt-7 flex flex-wrap items-center gap-3">
                        <CtaButton to="/contact" testid={SITE.bookConsultationCta}>
                            Schedule a consultation
                        </CtaButton>
                        <CtaButton to="/treatments" variant="secondary" icon={false}>
                            Explore treatments
                        </CtaButton>
                    </div>
                    <div className="mt-8 flex items-center gap-6 text-xs text-foreground/60">
                        <span className="inline-flex items-center gap-1.5">
                            <Sparkles className="h-3.5 w-3.5 text-sage" />
                            Certified Clinical Ayurvedic Practitioner
                        </span>
                        <span className="inline-flex items-center gap-1.5">
                            <Leaf className="h-3.5 w-3.5 text-sage" />
                            Classical lineage &middot; modern care
                        </span>
                    </div>
                </div>
                <div className="lg:col-span-5 reveal reveal-delay-2">
                    <div className="relative aspect-[4/5] w-full rounded-3xl overflow-hidden border border-border/70 shadow-[0_24px_60px_rgba(30,35,32,0.18)]">
                        <img
                            src="https://images.unsplash.com/photo-1545205597-3d9d02c29597?w=1600&auto=format&fit=crop"
                            alt="Ayurvedic herbs and oils"
                            className="h-full w-full object-cover"
                        />
                        <div className="absolute bottom-4 left-4 right-4 rounded-2xl bg-cream/95 border border-border/70 p-4 backdrop-blur">
                            <p className="font-display text-base text-moss leading-snug">
                                “Healing is the daily practice of returning to balance.”
                            </p>
                            <p className="mt-2 text-xs text-foreground/60">
                                — Riley Ann, founder
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default HomeIntroSection;
